export const actionsUserNotLoginedStyle = {
  wrapper: {
    minWidth: '175px',
    width: '100%',

    '@media (max-width: 767.98px)': {
      width: '100%',
    },
  },

  modal: {
    '.MuiPaper-root': {
      maxWidth: '972px',
      padding: '48px 12px',
      width: '100%',
    },
  },
};
